import { AutoHeightIframe, useIntl } from 'platform-components/common';
import React from 'react';

interface Props {
    src: string;
}

export const CustomLessonInfoModalContent = ({ src }: Props) => {
    const intl = useIntl();
    const defaultHeight = Number(intl.formatMessage({ id: 'customLesson.infoLanding.defaultHeight' }));

    return (
        <div className="custom-lesson-info-modal__landing-wrapper">
            <AutoHeightIframe defaultHeight={defaultHeight} origins={['https://yandex.ru']} src={src} />
        </div>
    );
};
